// Display helpers for versioned entities (86eybvqgn). The DB keys versions by
// familyId (a uuid); the UI shows a compact human-readable unique id derived
// from it: FRM-<code>-V<n> for forms, TPL-<code>-V<n> for procedure templates.

const shortCode = (familyId: string) =>
  familyId.replace(/[^a-zA-Z0-9]/g, '').slice(-5).toUpperCase()

export const versionLabel = (version: number | undefined | null) => `V${version ?? 1}`

export function formUniqueId(def: { id: string; familyId?: string; version?: number | null }): string {
  return `FRM-${shortCode(def.familyId ?? def.id)}-${versionLabel(def.version)}`
}

export function templateFamilyUniqueId(familyId: string): string {
  return `TPL-${shortCode(familyId)}`
}

export function templateUniqueId(proc: { id: string; familyId?: string; version?: number | null }): string {
  return `TPL-${shortCode(proc.familyId ?? proc.id)}-${versionLabel(proc.version)}`
}
